import {
  SisterSearcherPerformance,
  SisterSearcherPerformancePoint,
  SisterSearcherSearchRequest,
  SisterSearcherSearchResponse,
  SisterSearcherVessel,
  SisterSearcherVesselOption,
} from "../models/sister-searcher.models";
import { SISTER_SEARCHER_MODELED_DWT_TOLERANCE } from "../constants/sister-searcher.constants";

const selectedVesselFixture: SisterSearcherVessel = {
  imo: "1018755",
  vesselName: "SEA LYRA",
  dwt: 82276,
  design: "SDARI KMAX82NEW",
  keelLaid: "2024-07",
  build: 2025,
  yard: "China Merchants Qingdao",
  scrubber: "Open Loop",
  engineType: "6G50ME",
  country: "China",
  safetyScore: 4,
  ghg: "A",
  inImos: true,
  lbp: 225.5,
  depth: 20.4,
  draft: 14.5,
  breadth: 32.3,
  lastFixture: "07 Feb 2026",
  mcr: 7490,
  eexi: 2.82,
  ghgType: "EEXI",
  ihsDockingSurvey: "26 May 2028",
  ihsSpecialSurvey: "26 May 2030",
};

const sisterVesselFixtures: SisterSearcherVessel[] = [
  { imo: "1064752", vesselName: "TILEMACHOS", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2026-05", build: 2027, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "U", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1066764", vesselName: "PARMENION", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: null, build: 2027, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "U", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1113799", vesselName: "MAKRONISOS", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2026-05", build: 2027, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "U", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1113804", vesselName: "SOUPIA", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: null, build: 2027, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "U", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1042720", vesselName: "STAR EMMA", dwt: 82278, design: "SDARI KMAX82NEW", keelLaid: "2025-05", build: 2026, yard: "China Merchants Qingdao", scrubber: "None", engineType: "6G50ME", country: "China", safetyScore: 5, ghg: "A", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 8820, eexi: 2.89, ghgType: "EEXI", ihsDockingSurvey: "24 May 2029", ihsSpecialSurvey: "24 May 2031" },
  { imo: "1042732", vesselName: "STAR EVELINA", dwt: 82202, design: "SDARI KMAX82NEW", keelLaid: "2025-05", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: 5, ghg: "A", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 8820, eexi: null, ghgType: "EVDI", ihsDockingSurvey: "21 May 2029", ihsSpecialSurvey: "21 May 2031" },
  { imo: "1045954", vesselName: "EPIC C", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-11", build: 2026, yard: "China Merchants Qingdao", scrubber: "None", engineType: "6G50ME", country: "China", safetyScore: null, ghg: "A", inImos: true, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: "30 Aug 2026", mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1045966", vesselName: "LIONESS C", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-11", build: 2026, yard: "China Merchants Qingdao", scrubber: "None", engineType: "6G50ME", country: "China", safetyScore: null, ghg: "A", inImos: true, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: "10 Sep 2026", mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1055222", vesselName: "STAR IRINI", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-12", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "D", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 10320, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1055234", vesselName: "STAR ALINE", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-12", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "U", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 10320, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1055246", vesselName: "STAR ARGYRO", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-12", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: null, ghg: "D", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 10320, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: null },
  { imo: "1066738", vesselName: "YPERION", dwt: 81966, design: "SDARI KMAX82NEW", keelLaid: "2025-08", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: 4, ghg: "A", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: "16 Jun 2031" },
  { imo: "1066740", vesselName: "FAETHON", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2025-08", build: 2026, yard: "China Merchants Qingdao", scrubber: null, engineType: "6G50ME", country: "China", safetyScore: 4, ghg: "A", inImos: false, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: null, mcr: 7490, eexi: null, ghgType: null, ihsDockingSurvey: null, ihsSpecialSurvey: "09 Jul 2031" },
  { imo: "1037836", vesselName: "STAR ELENI", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2024-11", build: 2025, yard: "China Merchants Qingdao", scrubber: "Open Loop", engineType: "6G50ME", country: "China", safetyScore: 4, ghg: "A", inImos: true, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: "19 Dec 2025", mcr: 7490, eexi: 2.84, ghgType: "EEXI", ihsDockingSurvey: "18 Nov 2028", ihsSpecialSurvey: "18 Nov 2030" },
  { imo: "1037850", vesselName: "STAR ISMENE", dwt: 82000, design: "SDARI KMAX82NEW", keelLaid: "2024-12", build: 2025, yard: "China Merchants Qingdao", scrubber: "Open Loop", engineType: "6G50ME", country: "China", safetyScore: 4, ghg: "A", inImos: true, lbp: 225.5, depth: 20.4, draft: 14.5, breadth: 32.3, lastFixture: "15 Jan 2026", mcr: 7490, eexi: 2.84, ghgType: "EEXI", ihsDockingSurvey: "09 Dec 2028", ihsSpecialSurvey: "09 Dec 2030" },
];

const emptyPerformancePoint: SisterSearcherPerformancePoint = {
  cleanSpeed: null,
  consumption: null,
  currentSpeed: null,
  normalizedConsumption: null,
  cpSpeedConsumption: { speed: null, lsf: null, ifo: null, mgo: null, lsg: null, totalConsumption: null },
};

const allVesselFixtures = [selectedVesselFixture, ...sisterVesselFixtures];

export const getMockSisterSearcherVessels = (query: string, limit: number): SisterSearcherVesselOption[] => {
  const normalizedQuery = query.trim().toLowerCase();

  return allVesselFixtures
    .filter(
      (vessel) =>
        !normalizedQuery ||
        vessel.vesselName.toLowerCase().includes(normalizedQuery) ||
        vessel.imo.includes(normalizedQuery),
    )
    .slice(0, limit)
    .map(({ imo, vesselName }) => ({ imo, vesselName }));
};

export const searchMockSisterSearcherVessels = (
  request: SisterSearcherSearchRequest,
): SisterSearcherSearchResponse => {
  const selectedVessel = allVesselFixtures.find((vessel) => vessel.imo === request.imo) ?? null;

  if (!selectedVessel) {
    return { selectedVessel: null, sisterVessels: [], criteria: request };
  }

  const earliestBuild = (selectedVessel.build ?? 0) - request.yearsBefore;
  const latestBuild = (selectedVessel.build ?? 0) + request.yearsAfter;
  const sisterVessels = allVesselFixtures
    .filter((vessel) => vessel.imo !== selectedVessel.imo)
    .filter((vessel) => !request.sameCountryOfBuild || vessel.country === selectedVessel.country)
    .filter((vessel) => !request.sameDesign || vessel.design === selectedVessel.design)
    .filter(
      (vessel) =>
        !request.sameDwt ||
        (vessel.dwt !== null &&
          selectedVessel.dwt !== null &&
          Math.abs(vessel.dwt - selectedVessel.dwt) <= SISTER_SEARCHER_MODELED_DWT_TOLERANCE),
    )
    .filter((vessel) => !request.sameEngine || vessel.engineType === selectedVessel.engineType)
    .filter((vessel) => !request.sameYard || vessel.yard === selectedVessel.yard)
    .filter((vessel) => vessel.build === null || (vessel.build >= earliestBuild && vessel.build <= latestBuild))
    .filter((vessel) => request.inImos === "all" || vessel.inImos === (request.inImos === "yes"))
    .sort((left, right) => (right.build ?? 0) - (left.build ?? 0))
    .slice(0, request.limit);

  return { selectedVessel, sisterVessels, criteria: request };
};

export const getMockSisterSearcherPerformance = (imos: string[]): SisterSearcherPerformance[] =>
  imos.flatMap((imo) => {
    const vessel = allVesselFixtures.find((fixture) => fixture.imo === imo);

    if (!vessel) {
      return [];
    }

    return [
      {
        imo: vessel.imo,
        vesselName: vessel.vesselName,
        perfDataSource: null,
        evaluated: null,
        scrubber: vessel.scrubber,
        inImos: vessel.inImos,
        lastFixture: vessel.lastFixture,
        ecoBallast: emptyPerformancePoint,
        ecoLaden: emptyPerformancePoint,
        fullBallast: emptyPerformancePoint,
        fullLaden: emptyPerformancePoint,
      },
    ];
  });
